import PropTypes from 'prop-types';

import {NavLink} from 'react-router-dom';

import {
    Box,
    Breadcrumbs,
} from '@mantine/core';
import {NotificationSubscription} from '../types';

export const EditPageNavigation = ({component}: { component: NotificationSubscription }) => {

    const breadcrumbs = [{
        title: 'Home',
        href: '/dashboard',
    },
        {
            title: 'Notification Subscriptions',
            href: `/notification-subscriptions`,
        },
        {title: component.id}].map((item, index) => (
        <Box key={index}> {
            item
                .href ?
                <NavLink to={item.href}>{item.title}</NavLink> : item.title
        }
        </Box>
    ));

    return (
        <Box p={'xs'}><Breadcrumbs separator='→' mt='xs'>{breadcrumbs}</Breadcrumbs></Box>
    );
};

EditPageNavigation.propTypes = {
    component: PropTypes.shape({
                                   system: PropTypes.shape({name: PropTypes.string}),
                                   name: PropTypes.string,
                               }),
};